import React, { Component } from 'react';
import Radium, { Style } from 'radium';
import { Button, Breadcrumb, Container, Form, Header, Icon, Menu, Message, Modal, Search, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import moment from 'moment';
import ReactTable from 'react-table';
import SubNavigationBar from './../../navigation/SubNavigationBar';
import PasswordDisplayCoupon from '../PasswordDisplayCoupon';
import { Print } from 'react-easy-print';
import UpsertTableStyles from '../../styles/UpsertTableStyles';
import { AutoSizer } from 'react-virtualized';

const PASSWORD_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%';
const generatePassword = (length = 12) => {
  let password = '';
  for (let index = 0; index < length; index += 1) {
    password += PASSWORD_CHARS.charAt(Math.floor(Math.random() * PASSWORD_CHARS.length));
  }
  return password;
};

const DEFAULT_USERS_PAGE_SIZE = 25;

const getInitialState = () => ({
  users: {
    loading: false,
    data: [],
    total: 0,
    pageSize: DEFAULT_USERS_PAGE_SIZE,
    error: null
  },
  socios: {
    loading: false,
    data: [],
    total: 0,
    error: null
  },
  upsertModal: {
    open: false,
    values: {
      id: null,
      SocioId: 0,
      email: '',
      password: '',
      socioSearch: ''
    },
    successMessage: '',
    loading: false,
    error: null
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  }
});

class UsersView extends Component {

  constructor (props) {
    super(props);

    this.state = getInitialState();
    this.findUsersRequestId = 0;
    this._lastUsersQuery = { page: 0, pageSize: DEFAULT_USERS_PAGE_SIZE, $sort: { email: 1 } };

    this.SocioService = props.services.feathers.service('api/socios');
    this.UserService = props.services.feathers.service('api/users');
  }

  tableSortedToFeathersSort (sorted) {
    if (!sorted || !sorted.length) {
      return { email: 1 };
    }
    const s = sorted[0];
    if (s.id === 'email') {
      return { email: s.desc ? -1 : 1 };
    }
    return { email: 1 };
  }

  findSocios = () => {
    let { socios, upsertModal } = this.state;

    this.setState(update(this.state, {
      socios: {
        $merge: {
          loading: true,
          error: null,
          data: []
        }
      }
    }));

    this.SocioService.find({ query: { $limit: 100, search: upsertModal.values.socioSearch }})
      .then(response => {
        this.setState(update(this.state, {
          socios: {
            $merge: {
              loading: false,
              data: response.data,
              total: response.total
            }
          }
        }));
      })
      .catch(error => {
        this.setState(update(this.state, {
          socios: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  searchHandler = (e, { value }) => {
    this.setState(update(this.state, {
      upsertModal: {
        values: {
          $merge: {
            socioSearch: value
          }
        }
      }
    }), () => {
      if (this.state.upsertModal.values.socioSearch.length >= 3) {
        this.findSocios();
      }
    });
  }

  mapSociosToOptions (socios) {
    return socios.map((socio, index) => ({
      key: index,
      title: `${socio.concepto}`,
      description: `Nro. Socio ${socio.nro}`,
      value: socio
    }));
  }

  fetchUsersPage = ({ page, pageSize, $sort }) => {
    const sort = $sort && typeof $sort === 'object' ? $sort : { email: 1 };
    this._lastUsersQuery = { page, pageSize, $sort: sort };

    const requestId = this.findUsersRequestId + 1;
    this.findUsersRequestId = requestId;

    this.setState(prevState => update(prevState, {
      users: {
        $merge: {
          loading: true,
          error: null
        }
      }
    }));

    this.UserService.find({
      query: {
        $skip: page * pageSize,
        $limit: pageSize,
        $sort: sort,
        $populateSocio: true,
        $excludeSysadmin: true
      }
    })
      .then(response => {
        if (requestId !== this.findUsersRequestId) {
          return;
        }
        const rawRecords = Array.isArray(response && response.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];

        const records = Array.isArray(rawRecords)
          ? rawRecords.filter(record => !!record && typeof record === 'object')
          : [];

        const total = typeof response.total === 'number' ? response.total : records.length;

        this.setState(prevState => update(prevState, {
          users: {
            $merge: {
              loading: false,
              data: records,
              total,
              pageSize
            }
          }
        }));
      })
      .catch(error => {
        if (requestId !== this.findUsersRequestId) {
          return;
        }
        this.setState(prevState => update(prevState, {
          users: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  handleUsersTableFetch = (tableState) => {
    const { page, pageSize, sorted } = tableState;
    const $sort = this.tableSortedToFeathersSort(sorted);
    this.fetchUsersPage({ page, pageSize, $sort });
  }

  findUsers = () => {
    this.fetchUsersPage(this._lastUsersQuery);
  }

  inputHandler = (e, input) => {
    this.setState(update(this.state, {
      upsertModal: {
        values: {
          $merge: {
            [input.name]: input.value
          }
        }
      }
    }));
  }

  onSearchResultSelect = (e, input) => {
    this.setState(update(this.state, {
      upsertModal: {
        values: {
          $merge: {
            SocioId: input.result.value.id,
            socioSearch: input.result.value.concepto
          }
        }
      }
    }));
  }

  openUpsertModal = (e, input, record = null) => {
    let { upsertModal: { values }} = this.state;
    let newValues = values;

    if (record) {
      const socioLabel = record.socio && record.socio.concepto != null
        ? record.socio.concepto
        : (record.fullName || '');
      newValues = {
        id: record.id,
        email: record.email,
        password: '',
        SocioId: record.SocioId,
        socioSearch: socioLabel
      };
    } else {
      newValues = {
        ...newValues,
        password: generatePassword()
      };
    }

    this.setState(update(this.state, {
      upsertModal: {
        $merge: {
          open: true,
          values: newValues
        }
      }
    }));
  }

  dismissUpsertModal = (e, input) => {
    if (this.state.upsertModal.loading) {
      return;
    }

    this.setState(update(this.state, {
      upsertModal: {
        $set: getInitialState().upsertModal
      }
    }));
  }

  submitUpsert = (e, input) => {
    let { upsertModal: { values } } = this.state;
    this.setState(update(this.state, {
      upsertModal: {
        $merge: {
          loading: true,
          error: null,
          successMessage: ''
        }
      }
    }));

    if (values.id) {
      this.UserService.patch(values.id, {
        username: values.email,
        email: values.email,
        fullName: values.socioSearch,
        SocioId: values.SocioId
      })
        .then(response => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                successMessage: 'Usuario actualizado con exito'
              }
            }
          }), () => {
            this.findUsers();
          });
        })
        .catch(error => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                error
              }
            }
          }));
        });
    } else {
      this.UserService.create({
        username: values.email,
        email: values.email,
        password: values.password,
        fullName: values.socioSearch,
        SocioId: values.SocioId,
        needsReset: true,
        roles: ['client']
      })
        .then(response => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                successMessage: 'Usuario creado con exito',
                values: {...getInitialState().upsertModal.values, password: generatePassword()}
              }
            }
          }), () => {
            this.findUsers();
            //window.print();
            window.open(`/print/username/${values.email}/password/${values.password}`, "_blank", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=400,height=400");
          });
        })
        .catch(error => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                error
              }
            }
          }));
        });
    }
  }

  openRemoveModal = (e, input, id) => {
    this.setState(update(this.state, {
      removeModal: {
        $merge: {
          open: true,
          id
        }
      }
    }));
  }

  dismissRemoveModal = (e, input) => {
    this.setState(update(this.state, {
      removeModal: {
        $set: getInitialState().removeModal
      }
    }));
  }

  submitRemove = (e) => {
    this.setState(update(this.state, {
      removeModal: {
        $merge: {
          loading: true,
          error: null
        }
      }
    }));

    this.UserService.remove(this.state.removeModal.id)
      .then(response => {
        this.setState(update(this.state, {
          removeModal: {
            $set: getInitialState().removeModal
          }
        }), () => {
          this.findUsers();
        });
      })
      .catch(error => {
        this.setState(update(this.state, {
          removeModal: {
            $merge: {
              error
            }
          }
        }));
      });
  }

  static mapDispatchToProps (dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path))
    };
  }

  static mapStateToProps (state) {
    return {
      authentication: state.authentication.toJS()
    };
  }

  render () {
    const { t, authentication } = this.props;
    const { users, socios, upsertModal, removeModal } = this.state;
    const userPageSize = users.pageSize || DEFAULT_USERS_PAGE_SIZE;
    const userPageCount = Math.max(1, Math.ceil((users.total || 0) / userPageSize));
    const userRoles = authentication && authentication.user && authentication.user.roles
      ? authentication.user.roles
      : [];

    return (
      <AutoSizer disableHeight style={{ display: 'flex', flex: 1 }}>
        {
          ({ width }) => {
            let Wrapper = Container;
            let style = {};

            if (width < 764) {
              Wrapper = 'div';
              style = {
                margin: 0,
                width
              };
            }

            return (
              <Wrapper style={style}>

                <UpsertTableStyles />

                {
                  width >= 764 && <SubNavigationBar activeLink="usuarios" roles={userRoles} />
                }

                <Segment vertical secondary style={{ padding: 4 }}>
                  <Breadcrumb>
                    <Breadcrumb.Section as={Link} link to={'/dashboard'}>Inicio</Breadcrumb.Section>
                    <Breadcrumb.Divider icon="right angle" />
                    <Breadcrumb.Section as={Link} link to={'/administration'}>Administracion</Breadcrumb.Section>
                    <Breadcrumb.Divider icon="right angle" />
                    <Breadcrumb.Section active>Usuarios</Breadcrumb.Section>
                  </Breadcrumb>
                </Segment>

                <Segment clearing vertical>
                  <Button content="Refrescar" icon="refresh" positive onClick={this.findUsers} />
                  <Button content="Nuevo" floated="right" icon="add" primary onClick={this.openUpsertModal} />
                </Segment>

                {
                  users.error && <Message header={users.error.name} content={users.error.message} negative />
                }

                <ReactTable
                  className="-striped -highlight"
                  data={Array.isArray(users.data) ? users.data : []}
                  loading={users.loading}
                  manual
                  pages={userPageCount}
                  defaultPageSize={DEFAULT_USERS_PAGE_SIZE}
                  pageSizeOptions={[10, 25, 50, 100]}
                  defaultSorted={[{ id: 'email', desc: false }]}
                  onFetchData={this.handleUsersTableFetch}
                  columns={[
                    {
                      Header: '',
                      width: 32,
                      Cell: row => (
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            textAlign: 'center'
                          }}>
                          <Icon
                            className="edit-icon-hover" name="edit"
                            onClick={(e) => this.openUpsertModal(e, null, row.original)} />
                        </div>
                      ),
                      sortable: false,
                      resizable: false
                    },
                    {
                      Header: 'SOCIO',
                      columns: [
                        {
                          Header: 'Nro',
                          id: 'nroSocio',
                          accessor: d => d.socio ? d.socio.nro : '---',
                          sortable: false
                        },
                        {
                          Header: 'Nombre',
                          id: 'nombreSocio',
                          accessor: d => d.socio ? d.socio.concepto : '---',
                          sortable: false
                        }
                      ]
                    },
                    {
                      Header: 'USUARIO',
                      columns: [
                        {
                          Header: 'email',
                          id: 'email',
                          accessor: d => d.email
                        }
                      ]
                    },
                    {
                      Header: '',
                      width: 32,
                      Cell: row => (
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            textAlign: 'center'
                          }}>
                          <Icon
                            color="red"
                            className="trash-icon-hover" name="trash"
                            onClick={e => this.openRemoveModal(e, null, row.original.id)} />
                        </div>
                      ),
                      sortable: false,
                      resizable: false
                    }
                  ]}
                  previousText="<<"
                  nextText=">>"
                  loadingText="Cargando..."
                  noDataText="Sin Registros"
                  pageText="Pagina"
                  ofText="de"
                  rowsText="filas" />

                <Modal open={upsertModal.open} onClose={this.dismissUpsertModal}>
                  <Modal.Header>Alta y Modificacion de Usuario</Modal.Header>
                  <Modal.Content>
                    <Form loading={upsertModal.loading} onSubmit={this.submitUpsert} autoComplete="nope">
                      <Form.Group>
                        <Form.Input
                          control={Search}
                          label="Socio"
                          name="SocioId"
                          loading={socios.loading}
                          onResultSelect={this.onSearchResultSelect}
                          onSearchChange={this.searchHandler}
                          results={this.mapSociosToOptions(socios.data)}
                          noResultsMessage="Sin Resultados"
                          noResultsDescription="Redefina su busqueda"
                          selectFirstResult={true}
                          value={upsertModal.values.socioSearch} width={8} />
                      </Form.Group>
                      <Form.Group>
                        <Form.Input
                          name="email" label="Email" width={8}
                          value={upsertModal.values.email} onChange={this.inputHandler} />
                        <Form.Input
                          name="password" label="Clave" type="text" width={6} disabled={true || !!upsertModal.values.id}
                          value={upsertModal.values.password} onChange={this.inputHandler} />
                      </Form.Group>
                    </Form>
                    {
                      upsertModal.successMessage && <Message header="Operacion exitosa!" content={upsertModal.successMessage} positive />
                    }
                    {
                      upsertModal.error && <Message header={upsertModal.error.name} content={upsertModal.error.message} negative />
                    }
                  </Modal.Content>
                  <Modal.Actions>
                    <Button
                      basic content="Cancelar" icon="remove" negative
                      disabled={upsertModal.loading} onClick={this.dismissUpsertModal} />
                    <Button
                      content="Aceptar" icon="checkmark" positive
                      disabled={upsertModal.loading} onClick={this.submitUpsert} />
                  </Modal.Actions>
                </Modal>

                <Modal basic size="small" dimmer="blurring" open={removeModal.open} onClose={this.dismissRemoveModal}>
                  <Header icon="trash" content="Eliminar Usuario" />
                  <Modal.Content>
                    <p>Seguro desea eliminar el usuario?</p>
                    {
                      removeModal.error && <Message header={removeModal.error.name} content={removeModal.error.message} negative />
                    }
                  </Modal.Content>
                  <Modal.Actions>
                    <Button disabled={removeModal.loading} basic color="red" inverted onClick={this.dismissRemoveModal}>
                      <Icon name="remove" /> No
                    </Button>
                    <Button disabled={removeModal.loading} color="green" inverted onClick={this.submitRemove}>
                      <Icon name="checkmark" /> {removeModal.loading ? 'Eliminando ...' : 'Si'}
                    </Button>
                  </Modal.Actions>
                </Modal>
              </Wrapper>
            );
          }
        }
      </AutoSizer>
    );
  }

}

const StyledView = Radium(UsersView);
const i18nEnhancement = translate('translations')(StyledView);

export default connect(UsersView.mapStateToProps, UsersView.mapDispatchToProps)(i18nEnhancement);


// WEBPACK FOOTER //
// ./src/components/views/users/UsersView.jsx